<script setup>

</script>

<template>
  <div>

    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <div class="section__title">
              <h1>Arbitration deals</h1>
              <p>Browse a curated list of real-time arbitrage deals, complete with detailed information about the involved cryptocurrencies and exchanges.</p>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- statistics -->
    <div class="section section--pb">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-6 col-xl-3">
            <!-- stats -->
            <div class="stats">
              <span class="stats__value">1630</span>
              <p class="stats__name">This month's deals</p>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--purple"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--purple"></span>
            </div>
            <!-- end stats -->
          </div>

          <div class="col-12 col-sm-6 col-xl-3">
            <!-- stats -->
            <div class="stats">
              <span class="stats__value">$11.77</span>
              <p class="stats__name">Av. transaction revenue</p>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--orange"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--orange"></span>
            </div>
            <!-- end stats -->
          </div>

          <div class="col-12 col-sm-6 col-xl-3">
            <!-- stats -->
            <div class="stats">
              <span class="stats__value">$19 192</span>
              <p class="stats__name">Weekly income</p>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--green"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--green"></span>
            </div>
            <!-- end stats -->
          </div>

          <div class="col-12 col-sm-6 col-xl-3">
            <!-- stats -->
            <div class="stats">
              <span class="stats__value">$1.3M</span>
              <p class="stats__name">Total income</p>

              <!-- design elements -->
              <span class="stats__dodger stats__dodger--left stats__dodger--blue"></span>
              <span class="stats__dodger stats__dodger--right stats__dodger--blue"></span>
            </div>
            <!-- end stats -->
          </div>
        </div>
      </div>
    </div>
    <!-- end statistics -->

    <!-- deals -->
    <div class="section">
      <div class="container">
        <div class="row">
          <!-- deals table -->
          <div class="col-12">
            <div class="deals">
              <div class="deals__table-wrap">
                <table class="deals__table">
                  <thead>
                  <tr>
                    <th>Pair</th>
                    <th>Exchange</th>
                    <th>Date</th>
                    <th>Buying price</th>
                    <th>Selling price</th>
                    <th>Deal amount</th>
                    <th>Profit</th>
                    <th>Spread</th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr>
                    <td>
                      <div class="deals__text">BNB/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/binance.png" alt="">
                        <span class="green">Binance</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/bitget.png" alt="">
                        <span class="red">Bitget</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 01:09</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>304.3</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>305</div>
                    </td>
                    <td>
                      <div class="deals__text">$4 259</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$9.80</div>
                    </td>
                    <td>
                      <div class="deals__text">0.23%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">SOL/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/bitfinex.png" alt="">
                        <span class="green">Bitfinex</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/kraken.png" alt="">
                        <span class="red">Kraken</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 01:01</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>333.32</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>333.7</div>
                    </td>
                    <td>
                      <div class="deals__text">$8 204</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$9.35</div>
                    </td>
                    <td>
                      <div class="deals__text">0.11%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">ALGO/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/bithumb.png" alt="">
                        <span class="green">Bithumb</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/coinbase.png" alt="">
                        <span class="red">Coinbase</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:57</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>0.2181</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>0.21847</div>
                    </td>
                    <td>
                      <div class="deals__text">$8 040</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$13.64</div>
                    </td>
                    <td>
                      <div class="deals__text">0.17%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">BNB/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/coincheck.png" alt="">
                        <span class="green">Coincheck</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/gate.png" alt="">
                        <span class="red">Gate</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:51</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>1739.15</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>1741.32</div>
                    </td>
                    <td>
                      <div class="deals__text">$7 599</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$9.48</div>
                    </td>
                    <td>
                      <div class="deals__text">0.12%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">MATIC/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/kucoin.png" alt="">
                        <span class="green">Kucoin</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/okx.png" alt="">
                        <span class="red">OKX</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:48</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>2.1</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>2.3</div>
                    </td>
                    <td>
                      <div class="deals__text">$999</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$7.24</div>
                    </td>
                    <td>
                      <div class="deals__text">0.28%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">SOL/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/upbit.png" alt="">
                        <span class="green">Upbit</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/binance.png" alt="">
                        <span class="red">Binance</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:42</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>0.59</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>0.61</div>
                    </td>
                    <td>
                      <div class="deals__text">$3 524</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$12.05</div>
                    </td>
                    <td>
                      <div class="deals__text">0.18%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">BNB/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/okx.png" alt="">
                        <span class="green">OKX</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/bitget.png" alt="">
                        <span class="red">Bitget</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:35</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>23.66</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>23.89</div>
                    </td>
                    <td>
                      <div class="deals__text">$2 092</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$15.77</div>
                    </td>
                    <td>
                      <div class="deals__text">0.29%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">SOL/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/gate.png" alt="">
                        <span class="green">Gate</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/binance.png" alt="">
                        <span class="red">Binance</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:29</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>0.59</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>0.61</div>
                    </td>
                    <td>
                      <div class="deals__text">$1 500</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$9.07</div>
                    </td>
                    <td>
                      <div class="deals__text">0.16%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">BNB/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/bitfinex.png" alt="">
                        <span class="green">Bitfinex</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/kraken.png" alt="">
                        <span class="red">Kraken</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:28</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>23.66</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>23.89</div>
                    </td>
                    <td>
                      <div class="deals__text">$4 500</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$28.63</div>
                    </td>
                    <td>
                      <div class="deals__text">0.29%</div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="deals__text">ALGO/USDT</div>
                    </td>
                    <td>
                      <div class="deals__exchange">
                        <img src="img/exchanges/kucoin.png" alt="">
                        <span class="green">Kucoin</span>
                        <i class="ti ti-arrow-move-right"></i>
                        <img src="img/exchanges/okx.png" alt="">
                        <span class="red">OKX</span>
                      </div>
                    </td>
                    <td>
                      <div class="deals__text">15.11.23 00:26</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--buy"><i class="ti ti-currency-dollar"></i>0.2181</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--sell"><i class="ti ti-currency-dollar"></i>0.21847</div>
                    </td>
                    <td>
                      <div class="deals__text">$3 250</div>
                    </td>
                    <td>
                      <div class="deals__text deals__text--green">+$24.82</div>
                    </td>
                    <td>
                      <div class="deals__text">0.18%</div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!-- design elements -->
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
              <span class="screw screw--lines-tl"></span>
            </div>
          </div>
          <!-- end deals table -->

          <!-- paginator -->
          <div class="col-12">
            <div class="paginator">
              <span class="paginator__pages">10 from 183</span>

              <ul class="paginator__list-mobile">
                <li>
                  <a href="#">
                    <i class="ti ti-arrow-left"></i>
                    <span>Prev</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span>Next</span>
                    <i class="ti ti-arrow-right"></i>
                  </a>
                </li>
              </ul>

              <ul class="paginator__list">
                <li>
                  <a href="#"><i class="ti ti-arrow-left"></i></a>
                </li>
                <li><a href="#">1</a></li>
                <li class="active"><a href="#">2</a></li>
                <li><a href="#">3</a></li>
                <li><a href="#">4</a></li>
                <li><span>...</span></li>
                <li><a href="#">18</a></li>
                <li><a href="#">19</a></li>
                <li>
                  <a href="#"><i class="ti ti-arrow-right"></i></a>
                </li>
              </ul>
            </div>
          </div>
          <!-- end paginator -->
        </div>
      </div>
    </div>
    <!-- end deals -->

    <!-- question -->
    <section class="section">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <div class="question">
              <h2 class="question__title">Any questions?</h2>
              <p class="question__text">Our support team is always on call, and ready to help with all your questions!</p>

              <div class="section__btns section__btns--mt">
                <button class="section__btn section__btn--light" data-bs-target="#modal-ask" type="button" data-bs-toggle="modal">Ask a question</button>
              </div>

              <!-- design elements -->
              <span class="block-icon block-icon--orange">
							<i class="ti ti-info-circle"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--second" id="canvas2"></div>
        </div>
      </div>
    </section>
    <!-- end question -->

  </div>
</template>

<style scoped>

</style>
